// extracted by mini-css-extract-plugin
export var adCard = "_p8-8";
export var adCardBorder = "_p8-5";
export var arbiterButtonIcon = "_p8-p";
export var buttonIcon = "_p8-o";
export var container = "_p8-e";
export var copyButton = "_p8-m";
export var darkGrey = "_p8-u";
export var deliveryDate = "_p8-2";
export var divider = "_p8-n";
export var editModeWrapper = "_p8-7";
export var empty = "_p8-a";
export var errorIcon = "_p8-d";
export var filledCircle = "_p8-4";
export var fulfillmentFooter = "_p8-j";
export var grey = "_p8-s";
export var header = "_p8-i";
export var headerWrapper = "_p8-h";
export var highlighted = "_p8-6";
export var historyEntry = "_p8-3";
export var mobileColumn = "_p8-v";
export var mobileColumnReverse = "_p8-w";
export var orderDetailsContainer = "_p8-g";
export var orderMetadata = "_p8-l";
export var orderMetadataWrapper = "_p8-k";
export var packagesContainer = "_p8-b";
export var product = "_p8-y";
export var productImage = "_p8-z";
export var productInfo = "_p8-x";
export var productTitle = "_p8-10";
export var strikethrough = "_p8-t";
export var tinyText = "_p8-r";
export var title = "_p8-9";
export var trackerCard = "_p8-1";
export var trackerCardWrapper = "_p8-0";
export var trackingContainer = "_p8-f";
export var trackingTitle = "_p8-c";
export var xTinyText = "_p8-q";